exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2TrMK64U5CtN-pyC3eIu04{border:1px solid #757d8c;color:#2e3545;overflow:hidden;padding-left:1rem;text-overflow:ellipsis;white-space:normal}\n", ""]);

// exports
exports.locals = {
	"text": "_2TrMK64U5CtN-pyC3eIu04"
};